module.exports = __webpack_public_path__ + "static/media/git.2959a474.jpg";